import { useState, useEffect } from 'react'
import TlButton from '../components/button'
import Modal from '../components/mainModal'
import MainModalContent from '../components/mainModalContent'
import EmployerModalContent from '../components/employerModalContent'
import PartnerModalContent from '../components/partnerModalContent'
import JobseekerModalContent from '../components/jobseekerModalContent'

const HiringButton = (section) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState(null)

  const openModal = (e, page) => {
    e.preventDefault()
    setModalContent(<MainModalContent setModalContent={setModalContent} page={page} />)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (modalContent === 'employer') {
      setModalContent(<EmployerModalContent />)
    } else if (modalContent === 'partner') {
      setModalContent(<PartnerModalContent />)
    } else if (modalContent === 'jobseeker') {
      setModalContent(<JobseekerModalContent />)
    }
  }, [modalContent])

  return (
    <>
      {section.homepage && (
        <>
          <TlButton
            link="#"
            bgFrom="gradient2"
            bgTo="gradient2_80"
            hoverColour="gradient2_80"
            text="START HIRING"
            textSize="btn-xl"
            py="py-4"
            px="px-10"
            onClick={openModal}
          />
          <Modal isOpen={isModalOpen} closeModal={closeModal} content={modalContent} />
        </>
      )}
      {section.employer && (
        <>
          <TlButton
            link="#"
            text="START HIRING"
            textSize="text-btn-xl"
            bgFrom="gradient1"
            bgTo="gradient1_100"
            hoverColour="gradient1"
            px="px-8"
            py="py-4"
            onClick={(e) => openModal(e, 'employer')}
          />
          <Modal isOpen={isModalOpen} closeModal={closeModal} content={modalContent} />
        </>
      )}

      {section.hiring && (
        <>
          <TlButton
            link="#"
            text="START HIRING"
            textSize="text-btn-xl"
            w="w-full"
            bgFrom="gradient1"
            bgTo="gradient1_100"
            hoverColour="gradient1"
            px="px-8"
            py="py-4"
            onClick={openModal}
          />
          <Modal isOpen={isModalOpen} closeModal={closeModal} content={modalContent} />
        </>
      )}

      {section.eligibility && (
        <>
          <TlButton
            link="#"
            text="CONNECT EMPLOYER WITH TALENTLIFT"
            textSize="text-btn-xl"
            bgFrom="gradient1"
            bgTo="gradient1_100"
            px="px-6"
            py="py-3"
            onClick={openModal}
          />
          <Modal isOpen={isModalOpen} closeModal={closeModal} content={modalContent} />
        </>
      )}

      {section.team && (
        <>
          <TlButton
            link="#"
            text="MEET TALENTLIFT"
            textSize="text-btn-xl"
            w="w-full"
            bgFrom="gradient1"
            bgTo="gradient1_100"
            hoverColour="gradient1"
            px="px-6"
            py="py-4"
            onClick={openModal}
          />
          <Modal isOpen={isModalOpen} closeModal={closeModal} content={modalContent} />
        </>
      )}

      {section.partners && (
        <>
          <TlButton
            link="#"
            text="MEET TALENTLIFT"
            textSize="text-btn-xl"
            w="w-full"
            bgFrom="gradient1"
            bgTo="gradient1_100"
            hoverColour="gradient1"
            px="px-6"
            py="py-4"
            onClick={openModal}
          />
          <Modal isOpen={isModalOpen} closeModal={closeModal} content={modalContent} />
        </>
      )}

      {section.employer_hire && (
        <>
          <TlButton
            link="#"
            text="GET STARTED"
            textSize="text-btn-xl"
            bgFrom="gradient1"
            bgTo="gradient1_100"
            hoverColour="gradient1"
            px="px-6"
            py="py-4"
            onClick={openModal}
          />
          <Modal isOpen={isModalOpen} closeModal={closeModal} content={EmployerModalContent} />
        </>
      )}
      {section.candidate_hire && (
        <>
          <TlButton
            link="/employer-hire"
            text="FIND OUT MORE"
            textSize="text-btn-xl"
            bgFrom="gradient1"
            bgTo="gradient1_100"
            hoverColour="gradient1"
            px="px-6"
            py="py-4"
          />
        </>
      )}
    </>
  )
}

export default HiringButton
